module.exports = __webpack_public_path__ + "media/images/inbox/tab-left-arrow-41e03a0a561ac21d3c5a97539779cb5c.svg";